import React, { useState, useEffect } from 'react';
import { Container, makeStyles, CircularProgress } from '@material-ui/core';
import { GenericDrawer } from 'app/components/GenericDrawer/GenericDrawer';
import _ from 'lodash';

import { injectIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import GrowingTable from 'app/components/GrowingTable';
import VehicleForm from 'app/components/VehicleForm';

import helpers from 'app/utils/helpers';
import notification from 'app/config/notification';
import withVehicleInitialization from 'app/components/Hoc/withVehicleInitialization';

import { setVehicles, setDeletedVehicles } from 'app/store/slices/forms';
import { vehiclePayload } from 'app/utils/forms/payloadsStruture';
import { validateDocumentsDescription } from 'app/utils/forms/functions';
import { validateVehicleAge } from 'app/utils/forms/validators/vehicle';

import styles from './styles';
import { STATUS_CODES } from 'app/config/status';
import { daeIsPaid } from 'app/store/slices/daes';
import { MAX_VEHICLES_REQUEST } from 'app/utils/constants';
const useStyles = makeStyles(styles);

function TableAdd(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const {
        intl,
        initialLoading,
        setInitialLoading,
        openDrawer,
        setOpenDrawer,
        vehicleSelected,
        setVehicleSelected,
        reset,
        onCancel,
        onCloseDrawer,
        contextProps: { isInternalForm, canEdit },
    } = props;

    const vehicles = useSelector((state) => state.forms.vehicles);
    const deletedVehicles = useSelector((state) => state.forms.deletedVehicles);
    const vehicleType = useSelector((state) => state.vehicle.vehicleType);
    const subSystems = useSelector((state) => state.vehicle.subSystems);
    const userLogged = useSelector((state) => state.auth.user);
    const otherDocuments = useSelector((state) => state.forms.files);
    const request = useSelector((state) => state.requests.details);
    const internalNewRequest = useSelector((state) => state.forms.internalNewRequest);
    const activeCompany = useSelector((state) => state.company.activeCompany);

    const [company, setCompany] = useState({});
    const [maxVehicles, setMaxVehicles] = useState(0);

    useEffect(() => {
        if (maxVehicles === 0) {
            if (vehicles.length === 0) {
                setMaxVehicles(MAX_VEHICLES_REQUEST);
            } else if (request.cdSituacao > STATUS_CODES.EM_ANALISE && vehicles.length > 0) {
                setMaxVehicles(vehicles.length);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicles]);

    useEffect(() => {
        if (Object.keys(company).length > 0) return;
        if (Object.keys(activeCompany).length > 0) setCompany(activeCompany);
        else setCompany(internalNewRequest.company);
        // eslint-disable-next-line
    }, [activeCompany, internalNewRequest.company]);

    const [rows, setRows] = useState([]);

    const [canPartialEdit] = useState(() => {
        if (isInternalForm) return false;
        if (request.cdSituacao === STATUS_CODES.AGUARDANDO_PAGAMENTO && !isInternalForm) {
            return true;
        }
        return canEdit;
    });

    useEffect(() => {
        (async () => {
            if (vehicleType.length !== 0 && subSystems.length !== 0) {
                const vehiclesTemp = vehicles.map((v) => {
                    const temp = { ...v };
                    if (v.cdSubSistema) {
                        const found = _.find(subSystems, ['cdSubSistema', Number(v.cdSubSistema)]);
                        if (found && found.deSubSistema) {
                            temp.deSubSistema = found.deSubSistema;
                        }
                    }
                    temp.showEditButton = true;
                    temp.showDeleteButton = canPartialEdit;
                    return temp;
                });
                const tempTableData = { ...tableData };
                tempTableData.data = vehiclesTemp;
                setTableData(tempTableData);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subSystems, vehicleType, vehicles]);

    useEffect(() => {
        const temp = vehicles.map((v) => {
            const t = _.cloneDeep(v);
            t.showEditButton = true;
            t.showDeleteButton = canPartialEdit;
            return t;
        });
        setRows(temp);
    }, [canPartialEdit, vehicles]);

    const [tableData, setTableData] = useState({
        columns: [
            {
                title: 'ID',
                field: 'cdVeiculo',
                align: 'left',
                showContent: (value) => {
                    return <div>{value.cdVeiculo || '-'}</div>;
                },
            },
            {
                title: 'Placa',
                field: 'dePlaca',
                align: 'left',
                showContent: (value) => {
                    return <div>{value.dePlaca}</div>;
                },
            },
            {
                title: 'Renavam',
                field: 'deRenavam',
                align: 'left',
                showContent: (value) => {
                    return <div>{value.deRenavam}</div>;
                },
            },
            {
                title: 'n Ordem Empresa',
                field: 'nuOrdemEmpresa',
                align: 'left',
                showContent: (value) => {
                    return <div>{value.nuOrdemEmpresa}</div>;
                },
            },
            {
                title: 'Utilização',
                field: 'deUtilizacao',
                align: 'left',
                showContent: (value) => {
                    return <div>{value.deUtilizacao}</div>;
                },
            },
            {
                title: 'Subsistema',
                field: 'deSubSistema',
                align: 'left',
                showContent: (value) => {
                    return <div>{value.deSubSistema}</div>;
                },
            },
        ],
        data: rows,
    });

    const addElement = (vehi) => {
        setTableData(vehi);
    };

    const onChangeField = () => {};

    const onSaveRow = async (values, index) => {
        setInitialLoading(true);
        if (!values.documentos || values.documentos.length === 0) {
            notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_CRLV_REQUIRED' }), {
                toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_CRLV_REQUIRED',
                type: 'error',
            });
            setInitialLoading(false);
            return;
        }

        const valuesInt = { ...values };

        if (valuesInt.deUtilizacao === 'Sistema') {
            const subSystem = _.find(subSystems, ['cdSubSistema', Number(valuesInt.cdSubSistema)]);
            const maxAge = await validateVehicleAge({
                subSystem,
                chassiYear: valuesInt.nuAnoFabricacao,
                deUtilizacao: valuesInt.deUtilizacao,
            });
            if (subSystem && maxAge) {
                notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.VEHICLE_MAX_AGE_ADD' }), {
                    toastId: 'MESSAGES.SERVICE.VEHICLE_MAX_AGE_ADD',
                    type: 'error',
                });
                setInitialLoading(false);
                return;
            }
        }

        if (internalNewRequest?.cdUsuario) {
            valuesInt.cdUsuario = internalNewRequest.cdUsuario;
        } else {
            if (!isInternalForm) {
                valuesInt.cdUsuario =
                    userLogged.cdUsuarioAdmin && userLogged.cdUsuarioAdmin !== ''
                        ? userLogged.cdUsuarioAdmin
                        : userLogged.username;
            }
        }

        const docsExtrasValidation = validateDocumentsDescription(otherDocuments);
        if (!docsExtrasValidation && !isInternalForm) {
            notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }), {
                toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
                type: 'error',
            });
            setInitialLoading(false);
            return;
        }

        if (otherDocuments && otherDocuments.length > 0) {
            const documentsValues = _.cloneDeep(valuesInt.documentos);
            otherDocuments.forEach((doc) => {
                let key = _.findIndex(valuesInt.documentos, (d) => {
                    return d.idFile === doc.idFile;
                });

                if (key < 0) {
                    documentsValues.push(doc);
                } else {
                    documentsValues[key] = doc;
                }
            });
            valuesInt.documentos = documentsValues;
        }

        if (valuesInt.deCpfCnpjProprietario) {
            valuesInt.deCpfCnpjProprietario = helpers.somenteAlfanumericos(valuesInt.deCpfCnpjProprietario);
        }

        const temp = _.cloneDeep(vehicles);
        if (index != null) {
            temp[index] = valuesInt;
        } else {
            temp.push(valuesInt);
        }

        temp.showEditButton = canEdit;
        temp.showDeleteButton = canPartialEdit;

        const tableDt = { ...tableData };
        tableDt.data = temp;
        setTableData(tableDt);

        await dispatch(setVehicles(temp));

        reset();
        setInitialLoading(false);
    };

    const customEditElement = (element, index) => {
        const ele = {
            index,
            content: element,
        };
        setVehicleSelected(ele);
        setOpenDrawer(true);
    };

    const changeVehicles = async (index) => {
        if (index === undefined) {
            setVehicleSelected({ content: vehiclePayload });
            setOpenDrawer(true);
        } else {
            const temp = [...vehicles];
            const delVehicles = [...deletedVehicles];
            if (window.confirm('Deseja excluir este item?')) {
                setInitialLoading(true);

                if (request.cdSolicitacao) {
                    if (request.cdSituacao === STATUS_CODES.AGUARDANDO_PAGAMENTO && temp.length === 1) {
                        notification(
                            intl.formatMessage({
                                id: 'MESSAGES.SERVICE.FORMS.DELETE_VEHICLE_NOT_ALLOWED_EMPTY',
                            }),
                            {
                                toastId: 'MESSAGES.SERVICE.FORMS.DELETE_VEHICLE_NOT_ALLOWED_EMPTY',
                                type: 'error',
                            },
                        );
                        setInitialLoading(false);
                        return;
                    }
                    const isPaid = await daeIsPaid(request.cdSolicitacao, temp[index].dePlaca, intl);
                    if (isPaid) {
                        setInitialLoading(false);
                        return;
                    }
                    delVehicles.push(temp[index]);
                }

                temp.splice(index, 1);
                await dispatch(setVehicles(temp));
                await dispatch(setDeletedVehicles(delVehicles));

                setInitialLoading(false);
            }
        }
    };

    return (
        <>
            <GenericDrawer open={openDrawer} title="Cadastro de Veículo" onClose={() => onCloseDrawer()}>
                <Container>
                    <VehicleForm
                        {...props}
                        classes={classes}
                        vehicle={vehicleSelected}
                        onSave={onSaveRow}
                        onCancel={onCancel}
                        vehiclesLimit={maxVehicles}
                    />
                </Container>
            </GenericDrawer>
            {initialLoading && (
                <div className={classes.centerProgress}>
                    <CircularProgress size={20} />
                </div>
            )}

            {!initialLoading && (
                <>
                    <GrowingTable
                        title="Veículos"
                        titleTableLimit={'Número máximo de veículos nesta solicitação: '}
                        tableLimit={maxVehicles}
                        tabledata={tableData}
                        addtabledata={addElement}
                        customEditElement={customEditElement}
                        showEditButton={canEdit}
                        handlechange={onChangeField}
                        customAddElement={changeVehicles}
                        isInternalForm={isInternalForm}
                        canEdit={canEdit}
                    />
                    {tableData.data.length > 0 && (
                        <div className={classes.boxCount}>
                            <strong>Veículos adicionados</strong>
                            <span>{tableData.data.length}</span>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

export default injectIntl(withVehicleInitialization(TableAdd));
